module.exports = __webpack_public_path__ + "static/anli6.5642bdb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli6.jpg
// module id = 719
// module chunks = 168707334958949